import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { App } from './app/App.js';
import { SessionProvider } from './lib/session.js';
import { PwaExperience } from './pwa/pwa.js';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // A portaria fica com a tela aberta o dia inteiro: revalidar ao voltar
      // o foco mantem os contadores certos sem polling constante.
      refetchOnWindowFocus: true,
      staleTime: 30_000,
      retry: 1,
    },
  },
});

const container = document.getElementById('root');
if (!container) throw new Error('#root nao encontrado');

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <SessionProvider>
          <App />
          <PwaExperience />
        </SessionProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
